import { NegotiationDetail, UserPreference, NegotiationStatus } from 'api'
import { Locale, Translation } from 'locale'
import { HaircutTypeHelper } from 'model'
import React from 'react'
import { getLiveStatusText, getNegotiatedValue } from '../shared/utils'
import styled from '@emotion/styled'
import { makeHaircutFormatter, makeNotionalFormatter, makeRateFormatter } from 'view/shared/datagrid'

const notionalFormatter = makeNotionalFormatter()
const rateFormatter = makeRateFormatter()
const haircutFormatter = makeHaircutFormatter()

const CellContent = styled.span`
  padding: 10px;
`

export const getNegotiationsBreakdown = (negotiations: NegotiationDetail[] | null, userPreference: UserPreference) => {
  if (!negotiations?.length) return ''

  return (
    <table aria-label="Negotiations Breakdown">
      <thead>
        <tr>
          <th>
            <CellContent>{Locale.translate(Translation.TC_RFQ_ID)}</CellContent>
          </th>
          <th>
            <CellContent>{Locale.translate(Translation.TC_STATUS)}</CellContent>
          </th>
          <th>
            <CellContent>{Locale.translate(Translation.TC_MY_ENTITY)}</CellContent>
          </th>
          <th>
            <CellContent>{Locale.translate(Translation.TC_NOTIONAL, { amountFormat: userPreference?.amountFormat })}</CellContent>
          </th>
          <th>
            <CellContent>{Locale.translate(Translation.TC_RATE)}</CellContent>
          </th>
          <th>
            <CellContent>{Locale.translate(Translation.TC_HAIRCUT)}</CellContent>
          </th>
          <th>
            <CellContent>{Locale.translate(Translation.TC_HAIRCUT_TYPE)}</CellContent>
          </th>
        </tr>
      </thead>
      <tbody>
        {negotiations.map(n => {
          const haircutType = getNegotiatedValue(n.negotiation.haircutType)

          return (
            <tr key={n.negotiation.negotiationId}>
              <td>
                <CellContent>{n.negotiation.parentOrderId}</CellContent>
              </td>
              <td>
                <CellContent>
                  {n.negotiation.status === NegotiationStatus.REQUESTED_WITHOUT_PRICE
                    ? Locale.translate(Translation.TC_AWAITING)
                    : getLiveStatusText(n)}
                </CellContent>
              </td>
              <td>
                <CellContent>{n.orderFund?.alias ?? n.orderFund?.publishedName}</CellContent>
              </td>
              <td>
                <CellContent>
                  {notionalFormatter({
                    data: n,
                    value: getNegotiatedValue(n.negotiation.notional),
                    context: { userPreference }
                  } as any)}
                </CellContent>
              </td>
              <td>
                <CellContent>
                  {rateFormatter({
                    data: { ...n, referenceRate: n.negotiation.referenceRate },
                    value: getNegotiatedValue(n.negotiation.rate),
                    context: {
                      userPreference
                    }
                  } as any)}
                </CellContent>
              </td>
              <td>
                <CellContent>
                  {haircutFormatter({
                    data: n,
                    value: getNegotiatedValue(n.negotiation.haircut),
                    context: {
                      userPreference
                    }
                  } as any)}
                </CellContent>
              </td>
              <td>
                <CellContent>{haircutType && HaircutTypeHelper.getName(haircutType)}</CellContent>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
